import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

class UpdateUserDataSharingConsent extends baseRequest
{
    constructor(updateState, onError) {
        super();
        this.name = 'UpdateUserDataSharingConsent';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.updateState = updateState;
        this.onError = onError;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.config.api.requests.updateUserDataSharingConsent, payload);
    }

    onSuccess() {
        this.updateState(this.response.data);
    }

    onFailure(response, methodName) {
        if (typeof this.onError === 'function') {
            this.onError(response);
        }
        super.onFailure(response, methodName);
    }

    handleServerError(error) {
        if (typeof this.onError === 'function') {
            this.onError(error);
        }
        super.handleServerError(error);
    }
}

export default UpdateUserDataSharingConsent;
